import '../css/styles.scss'
import Site from './Site.js'

window._site = new Site()
